export default __webpack_public_path__ + "_/sounds/incubator_bet_max-c819a6da30d28b808aae11b1a662bdb730131ff52d283ae1f43cd5fea12c5beb.mp3";